import { render, staticRenderFns } from "./NoAuthorized.vue?vue&type=template&id=56043e2d&scoped=true"
var script = {}
import style0 from "./NoAuthorized.vue?vue&type=style&index=0&id=56043e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56043e2d",
  null
  
)

export default component.exports